import React from "react";
import { ButtonGroup } from "@8x8/oxygen-button";
import { StyledFilterIcon } from "@/react/components/styled/StyledIcons";
import { DisplayFilterButtonDropdown } from "@/react/components/table/components/filter/DisplayFilterButtonDropdown";

export function DisplayFilters({
  table,
  displayFilters,
  setFilterFnId,
  setFilterValue,
  removeFilter,
}) {
  return (
    <ButtonGroup spacing="small" align="left">
      <div>
        <StyledFilterIcon /> :
      </div>
      {Array.from(displayFilters.values()).map((displayFilter) => (
        <DisplayFilterButtonDropdown
          key={displayFilter.column.id}
          table={table}
          displayFilter={displayFilter}
          setFilterFnId={setFilterFnId}
          setFilterValue={setFilterValue}
          removeFilter={removeFilter}
        />
      ))}
    </ButtonGroup>
  );
}
